import { CmsResult, Page } from './fetch-nsp-data';

/**
 * A wrapper class for NSP context data, providing simple access to the internal
 * properties such as the lead form.
 */
export default class NspDataWrapper {
  readonly nspData: CmsResult;

  constructor(nspData: CmsResult) {
    this.nspData = nspData || {};
  }

  /** Gets the current NSP page data. */
  get page(): Page {
    return this.nspData.page || this.nspData.nmePage || this.nspData.ppcPage;
  }

  /** Gets the page-level lead form, if defined. */
  get leadForm() {
    return this.nspData.leadForm || this.page?.leadForm;
  }
}
